import { HttpClient } from '@angular/common/http';
import { of } from 'rxjs';
import get from 'lodash.get';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
var FooterService = /** @class */ (function () {
    function FooterService(http) {
        this.http = http;
        this.initialPageData = JSON.parse(get(document.getElementById('initialPageData'), 'innerHTML') || null);
    }
    FooterService.prototype.getFooter = function () {
        if (this.initialPageData && this.initialPageData.footer) {
            return of(this.initialPageData.footer);
        }
        return this.http.get("/ubaseline/api/bgfooter/getFooter");
    };
    FooterService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function FooterService_Factory() { return new FooterService(i0.ɵɵinject(i1.HttpClient)); }, token: FooterService, providedIn: "root" });
    return FooterService;
}());
export { FooterService };
